module.exports = __webpack_public_path__ + "img/empty_mizhua.d96822a.png";